export default __webpack_public_path__ + "static/media/Nycto_Cloyne.eb9c68f0.jpeg";